export default "__VITE_ASSET__CXYC4NSK__"